import type { ItemStatus } from '../domain/inventory';
import { statusFamilies, statusLabels } from '../domain/status';

/**
 * Lifecycle treatment option A (dot/shape + direct label): a circle for
 * real statuses, a rotated square (diamond) for STATUS_UNSPECIFIED so shape —
 * not just color — carries the "this is a data defect, not a status" meaning.
 * Raw backend enum names stay in the data model, not the routine operator view.
 */
export function StatusBadge({
  status = 'STATUS_UNSPECIFIED',
}: {
  status?: ItemStatus | undefined;
}) {
  const isUnspecified = status === 'STATUS_UNSPECIFIED';
  return (
    <span className="status-badge" data-family={statusFamilies[status]} data-status={status}>
      <span
        className={isUnspecified ? 'status-glyph status-glyph-diamond' : 'status-glyph'}
        aria-hidden="true"
      />
      <span className="status-label">{statusLabels[status]}</span>
    </span>
  );
}
